export default __webpack_public_path__ + "static/media/iconCard2.5bb999b2.svg";